export const AVATAR_ACCEPT = 'image/jpeg,image/png,image/webp';
export const AVATAR_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
export const AVATAR_MAX_INPUT_BYTES = 8 * 1024 * 1024;
export const AVATAR_MIN_EDGE = 128;
export const AVATAR_VIEW = 240;
export const AVATAR_OUTPUT = 512;
export const AVATAR_MIN_ZOOM = 1;
export const AVATAR_MAX_ZOOM = 3;

export function getAvatarErrorCode(file) {
  if (!file) return 'required';
  if (!AVATAR_TYPES.has(file.type)) return 'type';
  if (file.size > AVATAR_MAX_INPUT_BYTES) return 'size';
  return null;
}

export function loadImageFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      if (image.naturalWidth < AVATAR_MIN_EDGE || image.naturalHeight < AVATAR_MIN_EDGE) {
        URL.revokeObjectURL(url);
        reject(new Error('small'));
        return;
      }
      resolve({ image, url });
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('invalid'));
    };
    image.src = url;
  });
}

export function coverScale(image, view = AVATAR_VIEW) {
  return Math.max(view / image.naturalWidth, view / image.naturalHeight);
}

export function clampPan(image, zoom, panX, panY, view = AVATAR_VIEW) {
  const scale = coverScale(image, view) * zoom;
  const displayW = image.naturalWidth * scale;
  const displayH = image.naturalHeight * scale;
  const maxX = Math.max(0, (displayW - view) / 2);
  const maxY = Math.max(0, (displayH - view) / 2);
  return {
    x: Math.min(maxX, Math.max(-maxX, panX)),
    y: Math.min(maxY, Math.max(-maxY, panY)),
  };
}

export function cropFrame(image, zoom, panX, panY, view = AVATAR_VIEW) {
  const scale = coverScale(image, view) * zoom;
  const displayW = image.naturalWidth * scale;
  const displayH = image.naturalHeight * scale;
  return {
    scale,
    displayW,
    displayH,
    left: (view - displayW) / 2 + panX,
    top: (view - displayH) / 2 + panY,
  };
}

export function exportAvatarBlob(image, zoom, panX, panY) {
  const frame = cropFrame(image, zoom, panX, panY, AVATAR_VIEW);
  const ratio = AVATAR_OUTPUT / AVATAR_VIEW;
  const canvas = document.createElement('canvas');
  canvas.width = AVATAR_OUTPUT;
  canvas.height = AVATAR_OUTPUT;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.fillStyle = '#0c1219';
  ctx.fillRect(0, 0, AVATAR_OUTPUT, AVATAR_OUTPUT);
  ctx.drawImage(
    image,
    frame.left * ratio,
    frame.top * ratio,
    frame.displayW * ratio,
    frame.displayH * ratio
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('export'));
        return;
      }
      resolve(blob);
    }, 'image/jpeg', 0.88);
  });
}
